import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';

import type {
	AutomationRuleSummary as AutomationRuleSummaryQueryData,
	AutomationRuleSummaryVariables,
	ExperimentalAutomationRuleState,
} from '../__types__/AutomationRuleSummaryQuery.ts';

export const useExperimentalAutomationRuleSummaryQuery = ({
	skip,
	onError,
	variables,
}: {
	skip?: boolean;
	onError?: (error: Error) => void;
	variables: AutomationRuleSummaryVariables;
}) => {
	return useExperimentalQuery<
		AutomationRuleSummaryQueryData,
		AutomationRuleSummaryVariables,
		AutomationRuleSummaryResponse
	>({
		url: `/gateway/api/automation/internal-api/confluence/${variables.cloudId}/${variables.automationStack}/rest/${variables.spaceId}/rule/${variables.ruleId}/summary`,
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
		credentials: 'include',
		parseResult: (response: AutomationRuleSummaryResponse) => ({
			experimentalAutomationRuleSummary: {
				id: response.id,
				name: response.name,
				authorAccountId: response.authorAccountId,
				ruleState: response.ruleState,
				componentSummaries: response.componentSummaries,
			},
		}),
		skip,
		onError,
		variables,
	});
};

type AutomationComponentConfigSummary = {
	componentName: string;
	component: string;
	type: string;
	childComponentSummaries: AutomationComponentConfigSummary[];
};

type AutomationRuleSummaryResponse = {
	id: string;
	name: string;
	authorAccountId: string;
	ruleState: ExperimentalAutomationRuleState;
	componentSummaries: AutomationComponentConfigSummary[];
};
